export function getOktaIssuer(
  opts: { originOnly: boolean } = { originOnly: false }
) {
  const url = process.env.REACT_APP_OKTA_ISSUER;

  return opts.originOnly ? new URL(url).origin : url;
}
